import { render, staticRenderFns } from "./BlockAlert.vue?vue&type=template&id=59a5306e&scoped=true&"
import script from "./BlockAlert.vue?vue&type=script&lang=js&"
export * from "./BlockAlert.vue?vue&type=script&lang=js&"
import style0 from "./BlockAlert.vue?vue&type=style&index=0&id=59a5306e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a5306e",
  null
  
)

export default component.exports